import React from "react"
import config from "react-global-configuration"
import { getCssLegend } from "../../helpers/bookingHelper"
import * as path from "../../constants/Paths"
import { Link } from "react-router-dom"
import useWindowWidth from "../../../hooks/useWindowWidth"

export default function BookingExtensionProducts(props) {
  const windowWidth = useWindowWidth()
  BookingExtensionProducts.defaultProps = {
    isUnavailable: false,
    originalBooking: undefined,
  }

  const renderIcon = (isExtra, isCarService) => {
    if (isExtra) {
      return (
        //to do use new refund icon
        <svg className="svg-icon svg-icon--parking">
          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-parking">
            &nbsp;
          </use>
        </svg>
      )
    } else if (isCarService) {
      return (
        <svg className="svg-icon svg-icon--lounge">
          <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-carservice">
            &nbsp;
          </use>
        </svg>
      )
    }
    return (
      <svg className="svg-icon svg-icon--parking">
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-parking">
          &nbsp;
        </use>
      </svg>
    )
  }

  const renderProduct = (id, productName, description = null, price, isLast, isCarService, canCancel, isCancelled, manageBookingResult) => {
    const textKeys = config.get("textKeys.common.product") || {}
    const isAmendment = props.isAmendment ? true : false
    const legend = getCssLegend(description, productName)

    const query = {
      dd: manageBookingResult?.booking?.departureDate || "",
      dt: manageBookingResult?.booking?.departureTime || "",
      affiliate: manageBookingResult?.booking?.voucher || "",
      cfguid: manageBookingResult?.booking?.guid || "",
      email: manageBookingResult?.booking?.email || "",
      reference: manageBookingResult?.booking?.reference || "",
    }

    let isBookingPending = false
    let canEditBooking = false

    if (!isAmendment) {
      isBookingPending = props.isBookingPending(props.booking)
      canEditBooking = props.canEditBooking(props.cancellationInfo)
    }

    const thirdPartyPromoLabel = props.bookingExtension?.booking?.thirdPartyPromoLabelText

    const nameAndLabel =
      windowWidth > 450 ? (
        <h5 className="amend-product-header">{`${productName}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}`}</h5>
      ) : (
        <h5 className="amend-product-header">
          {productName}
          <br></br>
          {thirdPartyPromoLabel ? thirdPartyPromoLabel : ""}
        </h5>
      )

    return (
      <React.Fragment key={id}>
        <div
          className={`basket-product basket-product--slim basket-product--no-delete js--basket-product ${isLast ? "basket-product--last" : ""}
                        ${!isCancelled ? "basket-product--disabled" : ""} ${thirdPartyPromoLabel ? "shows-promo-label" : ""}`}
        >
          <div className="basket-product__details">
            {description ? (
              <div className="parking-legend parking-legend--list amend-list-view">
                <span className={`parking-legend__item parking-legend__item--${legend} amend-carpark-view`}>{description}</span>
                {nameAndLabel}
              </div>
            ) : (
              nameAndLabel
            )}
            {!isAmendment && !isCarService && isBookingPending && canEditBooking ? (
              <Link
                className="button-link--smalltext change-carpark-button-spacing"
                to={`${path.SEARCH_AMMEND_BOOKING()}${props.createQueryStrings(query)}`}
              >
                {textKeys.editCarpark || "Ret P-Anlæg"}
              </Link>
            ) : null}
          </div>
          <div className={`basket-product__price ${props.isUnavailable ? "strikethrough" : ""}`}>
            <span className="basket-product__price__sum">
              <em>{textKeys.valuta || "DKK"}</em> {props.priceFormatter(price, true)}
            </span>
          </div>
        </div>

        {!canCancel && isAmendment && isCarService ? (
          <div className="form__notice form__notice--box">
            {textKeys.refundOnlyOnline || "Det er ikke muligt at få refunderet bilpleje via hjemmesiden, dette skal gøres hos Københavns bilpleje"}
          </div>
        ) : null}
        {!canCancel && !isCancelled && isAmendment && !isCarService && !props.isFullValueCancellation() ? (
          <div className="form__notice form__notice--box">
            {textKeys.refundNotAvailable || "Det er ikke muligt at refundere refunderingsgarantien"}
          </div>
        ) : null}
      </React.Fragment>
    )
  }

  const { bookingExtension } = props
  const extensionBooking = bookingExtension
  let extensionProduct
  let extensionCarpark
  let extensionData

  if (extensionBooking) {
    extensionProduct = extensionBooking?.products[0] || {}
    extensionCarpark = extensionBooking?.carParks[0] || {}
    extensionData = extensionBooking?.parkingExtension || {}
  }

  return (
    <React.Fragment>
      {extensionBooking
        ? renderProduct(
            extensionProduct.id,
            extensionProduct.name,
            extensionCarpark.name,
            extensionData.priceChange < 0 && !extensionData.allowRefund ? 0 : extensionData.priceChange,
            false,
            false,
            extensionProduct.canCancel,
            bookingExtension,
          )
        : null}
    </React.Fragment>
  )
}

BookingExtensionProducts.defaultProps = {
  isUnavailable: false,
  originalBooking: undefined,
}
